import dayjs from "dayjs";
import Timezone from "dayjs/plugin/timezone";
import UTC from "dayjs/plugin/utc";

dayjs.extend(UTC);
dayjs.extend(Timezone);

function padToTwoDigits(num) {
  return num.toString().padStart(2, "0");
}

export const formatDate = (date) => {
  return [
    padToTwoDigits(date.getMonth() + 1),
    padToTwoDigits(date.getDate()),
    date.getFullYear(),
  ].join("/");
};

// Get current UTC timestamp.
export const getCurrentUTCTimestamp = () => {
  return dayjs().utc().format();
};

// Use this to convert UTC time and show local time.
export const getUTCToLocalDateTime = (date = "") => {
  if (!date) return "";
  const utcDateTime = dayjs.utc(date);
  return utcDateTime.local();
};
